import { Button, Flex, Popup, Spacing, Table, Text } from '@approvalmax/ui/src/components';
import { memo, useMemo } from 'react';

import { getTableColumns } from './PaymentDetailsDiscrepanciesPopupContent.columns';
import { messages } from './PaymentDetailsDiscrepanciesPopupContent.messages';
import { PaymentDetailsDiscrepanciesPopupContentProps } from './PaymentDetailsDiscrepanciesPopupContent.types';

export const PaymentDetailsDiscrepanciesPopupContent = memo<PaymentDetailsDiscrepanciesPopupContentProps>((props) => {
    const {
        requestName,
        paymentDetailsDiscrepancies,
        closePaymentDetailsDiscrepanciesPopup,
        handleApplyPaymentDetailsDiscrepancies,
    } = props;

    const tableColumns = useMemo(() => getTableColumns(), []);

    return (
        <>
            <Popup.Header
                title={messages.title}
                subTitle={requestName}
                actions={
                    <Flex spacing='16'>
                        <Button size='medium' color='red40' onClick={closePaymentDetailsDiscrepanciesPopup}>
                            {messages.cancel}
                        </Button>

                        <Button size='medium' color='blue80' onClick={handleApplyPaymentDetailsDiscrepancies}>
                            {messages.apply}
                        </Button>
                    </Flex>
                }
            />

            <Popup.Body spacing='32'>
                <Text font='body' fontSize='large'>
                    {messages.beforeTable}
                </Text>

                <Table data={paymentDetailsDiscrepancies} columns={tableColumns} headerColor='white100' />

                <Spacing height={24} />

                <Text font='body' fontSize='large'>
                    {messages.afterTable}
                </Text>
            </Popup.Body>
        </>
    );
});

PaymentDetailsDiscrepanciesPopupContent.displayName = 'PaymentDetailsDiscrepanciesPopupContent';
